module.exports = __webpack_public_path__ + "static/media/CHT_logo_color.c5a6c16d.png";